import {ChangeDetectionStrategy, Component, Input, Signal} from '@angular/core';
import {NgClass} from '@angular/common';
import {Store} from '@ngxs/store';
import {DashboardViewRegion} from '../../../dashboard-view-regions/types/dashboard-view-regions.types';
import {turnRightDownAnimation} from '../../../shared/animations/turn-right-down.animation';
import {NestedExpansionPanelComponent} from '../../../shared/components/nested-expansion-panel/nested-expansion-panel.component';
import {SelectViewRegion} from '../../../dashboard-view-regions/states/dashboard-view-regions/dashboard-view-regions.actions';

@Component({
  selector: 'app-dashboard-study-data-view-region',
  templateUrl: './dashboard-study-data-view-region.component.html',
  styleUrls: ['./dashboard-study-data-view-region.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, NestedExpansionPanelComponent],
  animations: [turnRightDownAnimation()],
})
export class DashboardStudyDataViewRegionComponent {
  @Input({required: true}) activeViewRegionId: Signal<DashboardViewRegion['id']>;
  @Input({required: true}) viewRegion: DashboardViewRegion;
  @Input({required: true}) level: number;

  constructor(private store: Store) {}

  /**
   * Toggle the provided expansion panel.
   */
  public toggleRelatedPanel(expansionPanel: NestedExpansionPanelComponent, event: MouseEvent): void {
    expansionPanel.togglePanel();
    event.preventDefault();
    event.stopPropagation();
  }

  /**
   * Focus the provided view region.
   */
  public focusViewRegion(viewRegion: DashboardViewRegion) {
    this.store.dispatch(new SelectViewRegion(viewRegion.id));
  }
}
